export class UnblindedInfo {
    constructor(
        public studyId: number,
        public protocolNum: string,
        public subjectNum: string,
        public drug: string
    ) {}
}
